export const PRIMARY_SUBJECT_AREA = 'primary-subject-area';

export const GEO_DISCOUNT_CODE = 'EDXGEO';
